import verticalBarChartSpec, {
  addFilterSignalBarChart,
} from "utils/verticalBarChartSpec";
import histogramSpec, { addFilterSignal } from "utils/histogramSpec";
import vegaEmbed from "vega-embed";
import { compile } from "vega-lite/build/vega-lite";
const grades = [
  "Pre-K",
  "K",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "Not a teacher",
];
const subjects = [
  "Administrator",
  "Arts/Music/Drama",
  "ELA",
  "ESL/ELL",
  "Foreign Language",
  "History/ Social Studies",
  "Math",
  "Other (Please specify):",
  "PE / Health / Athletic",
  "Science",
  "Self-contained elementary classroom",
  "Special Education/Learning Support/Special Services",
  "Technology/ Tech Integration",
];
const valuable = [
  "Always Valuable",
  "Usually Valuable",
  "Sometimes Valuable",
  "Never Valuable",
];
const agreement = [
  "Strongly Agree",
  "Agree",
  "Neutral",
  "Disagree",
  "Strongly Disagree",
];
const devices = [
  "1 device",
  "2 devices",
  "3 devices",
  "4 devices",
  "5 devices",
  "6 or more devices",
  "None",
];
const flavors = [
  "Butter Pecan",
  "Chocolate",
  "Coffee",
  "Cookie Dough",
  "Cookies and Cream",
  "Mint Chocolate Chip",
  "Peanut Butter",
  "Pistachio",
  "Strawberry",
  "Vanilla",
];

export function generate() {
  return {
    "Grade Level": {
      chartType: "barchart",
      domain: grades,
      data: [],
    },
    "Subjects Taught": {
      chartType: "barchart",
      domain: subjects,
      data: [],
    },
    "Years taught throughout career": {
      chartType: "histogram",
      data: [],
    },
    "Years in current role": {
      chartType: "histogram",
      data: [],
    },
    "Years taught in 1:1 setting": {
      chartType: "histogram",
      data: [],
    },
    "Age": {
      chartType: "barchart",
      domain: [
        "Under 20",
        "20-29 years old",
        "30-39 years old",
        "40-49 years old",
        "50-59 years old",
        "60 -69 years old",
        "70 or over",
      ],
      data: [],
    },
    "Value of Drill and practice": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Assessment": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Note taking": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Researching topics": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Digital media production": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Multimedia presentations": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Data analysis": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Simulations": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Student collaboration": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of PBL/CBL": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Student reflection": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Open-ended learning experience": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Educational gaming": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Value of Making/maker spaces": {
      chartType: "barchart",
      domain: valuable,
      data: [],
    },
    "Coaching is more effective than lecturing": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Technology helps students grasp difficult curricular concepts": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Students work harder at their assignments when technology is incorporated": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Technology makes the management of my classes‚ assignments, and projects easier": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Technology allows students to be more efficient": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Technology allows students to be more creative": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Technology is negatively impacting the attention spans of my students": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Students are more likely to plagiarize or cheat when technology is incorporated": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Students are more engaged when technology is incorporated": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Students are unable to assess the authenticity/ trustworthiness of Internet sources": {
      chartType: "barchart",
      domain: agreement,
      data: [],
    },
    "Home access to laptops/computers": {
      chartType: "barchart",
      domain: devices,
      data: [],
    },
    "Home access to iPads/tablets": {
      chartType: "barchart",
      domain: devices,
      data: [],
    },
    "Home access to smart phones": {
      chartType: "barchart",
      domain: devices,
      data: [],
    },
    "Home time using tech for school (non-school day)": {
      chartType: "histogram",
      data: [],
    },
    "Home time using tech for school (school day)": {
      chartType: "histogram",
      data: [],
    },
    "Home time using tech for personal (non-school day)": {
      chartType: "histogram",
      data: [],
    },
    "Home time using tech for personal (school day)": {
      chartType: "histogram",
      data: [],
    },
    "Ice Cream Favored Flavor": {
      chartType: "barchart",
      domain: flavors,
      data: [],
    },
  };
}

export function prepareData(data, labels, schools) {
  const visData = generate(); // data template

  // remove unnecessary props
  const displayMap = labels.reduce((acc, d) => {
    acc[d["Variable Name"]] = {
      displayLabel: d["Display Label"],
      variableLabel: d["Variable Label"],
    };
    return acc;
  }, {});

  // transform data

  data.forEach((record) => {
    // console.log('record', record)
    Object.entries(record).map(([prop, value]) => {
      if (prop === "ResponseId" || prop == "Q2") {
        //Q2 : "SCHOOL-ADMIN ONLY"
        return;
      }

      if (
        prop !== "ResponseId" &&
        prop !== "Q2" &&
        (displayMap[prop].displayLabel === "Not displayed" || value == "")
      ) {
        return;
      }
      if (schools.includes(record["Q2"]) === false) {
        return;
      }
      const label = displayMap[prop].displayLabel;

      value = value.trim();
      visData[label].data.push({
        responseId: record["ResponseId"],
        school: record["Q2"],
        type: label,
        [label]: value,
      });
    });
  });
  return visData;
}

export function createCharts(
  data,
  questions,
  containers,
  setTotalCallback = ()=>{},
  markColor = "#00bfa5",
  highlightColor = "#ffab00"
) {
  const charts = [];
  Object.entries(data).map(async (d, i) => {
    const question = d[0];

    // const domain = d[1].dp,aom;
    // console.log(question, questions);

    let chartData = d[1].data; //data.filter((d) => d.type === question);
    // console.log(chartData, question, domain);
    // chartData = JSON.parse(JSON.stringify(chartData))
    // console.log(chartSpec);
    const chartType = d[1].chartType;
    const domain = d[1].domain;
    let chart;

    if (chartType === "histogram") {
      const chartSpec = histogramSpec(
        chartData,
        question,
        null,
        markColor,
        highlightColor
      );
      let vegaSpec = compile(chartSpec).spec;
      addFilterSignal(vegaSpec);
      const index = questions.findIndex(q=>q===question)
      // console.log('index', index);
      chart = await vegaEmbed(containers[index], vegaSpec);
    } else {
      const chartSpec = verticalBarChartSpec(
        chartData,
        question,
        domain,
        "Number of Responses",
        null,
        markColor,
        highlightColor
      );
      const vegaSpec = compile(chartSpec).spec;
      addFilterSignalBarChart(vegaSpec);
      const index = questions.findIndex(q=>q===question)
      // console.log('index', index);
      chart = await vegaEmbed(containers[index], vegaSpec);
    }
    charts.push(chart);

    chart.view.addSignalListener("select", (name, value) => {
      // console.log(combined, question, value)
      // filter data
      // 1. filter data and get the corresponding responses
      // pre-compute combine data
      const combined = Object.values(data)
        .map((d) => d.data)
        .flat();
      let allIds = combined
        .filter(
          (d) =>
            d.type === question &&
            value[question] &&
            (chartType === "histogram"
              ? value[question][0] <= d[question] &&
                d[question] <= value[question][1]
              : value[question].includes(d[question]))
        )
        .reduce((acc, record) => {
          acc[record.responseId] = true;
          return acc;
        }, {});

      // 2. extrapolate the response IDs to include other data
      setTotalCallback(Object.keys(allIds).length);
      allIds = combined.filter((d) => allIds[d.responseId]);
      

      Object.entries(data).map((d, i) => {
        // get responses per each question
        const ids = allIds
          .filter((f) => f.type === d[0])
          .map((d) => d.responseId);

        
        try {
          // console.log("filter selection", charts[i].view.signal("filter_selection"));
          charts[i].view.signal("filter_selection", ids).runAsync();
        } catch (err) {
          console.error(err, charts[i].view.getState());
        }
      });
    });
  });
}
export default {
  generate,
  createCharts,
  prepareData,
};
